/**
 * Initializes the footer mobile Swiper when viewport is under 768px and a qualifying section exists.
 * Loaded deferred; Swiper must be available on templates that include swiper.js.
 *
 * Group-blocks are moved into swiper slides using DOM node moves (not innerHTML cloning) so that
 * event listeners, custom-element state, and app widget state are preserved across init/reset cycles.
 */
(function () {
  let footerMobileSwiper = null;
  let footerMobileSectionWrapper = null;

  function ensureSwiperReady(callback) {
    if (typeof Swiper !== 'undefined') {
      callback();
      return;
    }

    if (typeof window.__amLoadSwiper === 'function') {
      window.__amLoadSwiper()
        .then(function () { callback(); })
        .catch(function () {});
      return;
    }

    setTimeout(function () { ensureSwiperReady(callback); }, 120);
  }

  function resetFooterMobileSection() {
    if (footerMobileSwiper) {
      try {
        footerMobileSwiper.destroy(true, true);
      } catch (error) {
        /* ignore */
      }
      footerMobileSwiper = null;
    }

    if (!footerMobileSectionWrapper) {
      return;
    }

    const existingSwiper = footerMobileSectionWrapper.querySelector('.footer-mobile-swiper');
    if (existingSwiper) {
      // Move group-blocks back to the wrapper before removing the swiper container.
      // Using DOM node moves (not innerHTML) preserves event listeners and custom-element state.
      existingSwiper.querySelectorAll('.swiper-slide').forEach(function (slide) {
        const group = slide.firstElementChild;
        if (group) footerMobileSectionWrapper.appendChild(group);
      });
      existingSwiper.remove();
    }

    footerMobileSectionWrapper = null;
  }

  function initFooterMobileSlider() {
    if (window.innerWidth >= 768) {
      resetFooterMobileSection();
      return;
    }

    if (typeof Swiper === 'undefined') {
      ensureSwiperReady(initFooterMobileSlider);
      return;
    }

    if (footerMobileSectionWrapper && !document.body.contains(footerMobileSectionWrapper)) {
      footerMobileSectionWrapper = null;
      footerMobileSwiper = null;
    }

    if (footerMobileSectionWrapper && footerMobileSectionWrapper.querySelector('.footer-mobile-swiper')) {
      return;
    }

    const allMobileSections = document.querySelectorAll('.sec-hide-desktop.sec-show-mobile');
    let sectionWrapper = null;
    let groups = [];

    for (const section of allMobileSections) {
      const wrapper = section.querySelector('.section-content-wrapper');
      if (!wrapper) continue;

      const foundGroups = Array.from(wrapper.children).filter(function (el) {
        return el.classList.contains('group-block');
      });

      if (foundGroups.length >= 4) {
        sectionWrapper = wrapper;
        groups = foundGroups.slice(0, 4);
        break;
      }
    }

    if (!sectionWrapper || groups.length < 4) {
      return;
    }

    const existingSwiper = sectionWrapper.querySelector('.footer-mobile-swiper');
    if (existingSwiper) {
      footerMobileSectionWrapper = sectionWrapper;
      return;
    }

    const swiperContainer = document.createElement('div');
    swiperContainer.className = 'swiper footer-mobile-swiper';

    const swiperWrapper = document.createElement('div');
    swiperWrapper.className = 'swiper-wrapper';

    // Move group-blocks into slides — DOM node move, not cloneNode, so state is preserved.
    groups.forEach(function (group) {
      const slide = document.createElement('div');
      slide.className = 'swiper-slide';
      slide.appendChild(group);
      swiperWrapper.appendChild(slide);
    });

    swiperContainer.appendChild(swiperWrapper);
    sectionWrapper.insertBefore(swiperContainer, sectionWrapper.firstChild);
    footerMobileSectionWrapper = sectionWrapper;

    try {
      footerMobileSwiper = new Swiper(swiperContainer, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        touchEventsTarget: 'wrapper',
        allowTouchMove: true,
        grabCursor: true,
        speed: 500,
        observer: false,
        observeParents: false,
      });
    } catch (error) {
      resetFooterMobileSection();
    }
  }

  function init() {
    const target = document.querySelector('.sec-hide-desktop.sec-show-mobile');
    if (!target) {
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
      return;
    }
    const io = new IntersectionObserver(
      function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        const run = function () {
          if (typeof requestIdleCallback !== 'undefined')
            requestIdleCallback(function () { ensureSwiperReady(initFooterMobileSlider); }, { timeout: 2000 });
          else setTimeout(function () { ensureSwiperReady(initFooterMobileSlider); }, 0);
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
        else run();
      },
      { rootMargin: '300px' }
    );
    io.observe(target);
  }

  init();

  document.addEventListener('shopify:section:load', initFooterMobileSlider);

  let resizeTimeout;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(initFooterMobileSlider, 150);
  });
})();
